// format "Mer. 21 mai 2025 à 10h15"
export function formatDetailsDate (date, locale) {
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    locale: locale
  }
  const formatter = new Intl.DateTimeFormat(locale, options)
  const formattedDate = formatter.format(date)
  
  return locale === 'fr-FR' ? formattedDate.replace(/:/, 'h') : formattedDate
}	

 // format "2025-05-21"
export function formatDateToISO(date) {
  if (!date) return null;
  return new Date(date).toISOString().split('T')[0];
}
